import React from "react";
import styles from "./payment.module.css";

export default function PaymentMethodCard({
  rowKey,
  selected,
  disabled,
  locked,
  lockSecondsRemaining,
  icon,
  label,
  description,
  /** Extra content shown on the right when the row is collapsed (e.g. scheme brand logos + "+ N"). */
  collapsedTrailing,
  /** If true, description is only shown while the row is expanded (compact collapsed row). */
  hideDescriptionWhenCollapsed,
  children,
  onSelect,
}) {
  const collapsed = !selected;

  return (
    <div
      className={`${styles.card} ${selected ? styles.cardSelected : ""} ${collapsed ? styles.cardCollapsed : ""} ${disabled ? styles.cardDisabled : ""}`}
      data-pm-row={rowKey}
    >
      <button
        type="button"
        className={styles.cardHeader}
        onClick={() => !disabled && onSelect()}
        aria-expanded={selected}
        disabled={disabled}
      >
        <span className={styles.cardHeaderMain}>
          <span className={styles.cardIconWrap}>
            <img src={icon} alt="" className={styles.cardIcon} />
          </span>
          <span className={styles.cardTitles}>
            <span className={styles.cardLabel}>{label}</span>
            {locked ? (
              <span className={styles.lockedBadge}>
                Locked · retry in {lockSecondsRemaining}s
              </span>
            ) : null}
          </span>
        </span>
        {collapsed && collapsedTrailing ? (
          <span className={styles.collapsedTrailing}>{collapsedTrailing}</span>
        ) : null}
      </button>
      <div
        className={styles.cardPanel}
        style={{
          gridTemplateRows: selected ? "1fr" : "0fr",
        }}
      >
        <div className={styles.cardPanelInner}>{selected ? children : null}</div>
      </div>
    </div>
  );
}
